export const barColors = {
  revenue: {
    firstYear: '#CBD4E0',
    secondYear: '#4892EE'
  },
  bookings: {
    firstYear: '#DDD8C9',
    secondYear: '#EAB20F'
  },
  messages: {
    firstYear: '#D7DADC',
    secondYear: '#2B6CB0'
  }
}

export const barSize = 10

export const dataTypesToShow = {
  Consumed: 'Consumed',
  Cancellation: 'Cancellation',
  OTA: 'OTA',
  Direct: 'Direct'
}

export const dataTypesToShowNames = {
  Consumed: 'Consumed',
  Cancellation: 'Cancelled',
  OTA: 'OTA',
  Direct: 'Direct'
}
